import { apiRequest } from '@/plugins/api.js';
import { apiResponseTypeEnum } from '@/constants/api.js';

export const apiRetrieveLeaderboardData = ({ payload }) => apiRequest({
  url: 'api/getPrizeLeaderboardDetails',
  method: 'POST',
  data: payload,
}).then((response) => {
  const responseData = response?.data?.data?.find(item => item);

  if (response?.data?.responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum: response?.data?.responseEnum });
  }

  return { parsedData: responseData };
});
